import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const useEnumAttributeService = () => {
    // eslint-disable-next-line
    const [enumAttributeService, setEnumAttributeService] = useState<any>();
    useEffect(() => {
        const angularJSInjector = getInjector();
        const enumAttributeService = angularJSInjector.get('EnumAttributeService');
        setEnumAttributeService(enumAttributeService);
    }, []);
    return { enumAttributeService };
};

export default useEnumAttributeService;
